import { components } from "@/api-schema";

type MergeConflict = components["schemas"]["MergeConflictResponse"];

export const groupConflictsByKey = (conflicts: MergeConflict[]): Map<string, MergeConflict[]> => {
  const groups = new Map<string, MergeConflict[]>();

  for (const conflict of conflicts) {
    const group = groups.get(conflict.key);
    if (group) {
      group.push(conflict);
    } else {
      groups.set(conflict.key, [conflict]);
    }
  }

  return groups;
};
